import { OrderType } from '../enums/order-type.enum'

export interface IPaginationRequest {
  page?: number
  limit?: number
  query?: string
  orderField?: string
  orderType?: OrderType
}
